(() => {
  'use strict';

  // Retracts the fixed header while the page is being scrolled down on a phone, and
  // brings it back the moment the scroll reverses.
  //
  // The bar is 58px of a 812px screen that never moves — on a product page it sits over
  // the plate for the entire scroll. On desktop that is a rounding error; on a phone it
  // is seven per cent of everything the visitor can see, spent on navigation they are
  // not currently using. Scrolling up is the gesture for "take me back", so that is when
  // the bar is worth its height.
  //
  // Phones only. The desktop header is deliberately always present.

  const header = document.querySelector('.meningea-header');
  if (!header) return;

  const mq = window.matchMedia('(max-width: 749px)');
  // Below this the page has barely moved, and retracting there makes the bar flicker at
  // the very top of a short page.
  const ARM_AT = 90;
  // A scroll has to reverse by more than this to count. Without it, the few pixels of
  // overshoot at the end of a flick, and the rubber-banding iOS does at both ends of the
  // document, read as a direction change and the bar twitches.
  const SLOP = 8;

  let last = window.scrollY;
  let anchor = window.scrollY;
  let down = true;
  let hidden = false;

  function setHidden(next) {
    if (next === hidden) return;
    hidden = next;
    header.classList.toggle('is-retracted', next);
  }

  // Run straight off the scroll event rather than inside requestAnimationFrame. The work
  // is two reads of window.scrollY and a class toggle that only fires on a change, so
  // there is nothing to batch — and rAF is throttled hard whenever the page is not being
  // actively painted (low power mode, a backgrounded tab, an inactive preview pane), which
  // would leave the bar stuck in whichever state it was last in.
  function measure() {
    const y = Math.max(0, window.scrollY);
    const movingDown = y > last;

    // Track the furthest point in the current direction, so the comparison is against
    // where the reversal started rather than against the previous frame — a slow drag
    // otherwise never accumulates enough difference to clear SLOP.
    if (movingDown !== down) {
      down = movingDown;
      anchor = last;
    }
    last = y;

    if (y <= ARM_AT || isOpen()) {
      setHidden(false);
      return;
    }
    if (down && y - anchor > SLOP) setHidden(true);
    else if (!down && anchor - y > SLOP) setHidden(false);
  }

  function onScroll() {
    if (!mq.matches) {
      setHidden(false);
      return;
    }
    measure();
  }

  // The menu and the cart drawer both live inside this header, so if the bar retracted
  // while one of them was open the panel would slide off the screen with it. Any open
  // overlay therefore pins the bar down.
  //
  // The two signal openness differently — the menu is a <details>, so it carries `open`,
  // while the drawer sets aria-expanded on its trigger — and watching the attributes
  // rather than subscribing to either script's events keeps this file independent of
  // both. isOpen is also consulted on every scroll, not just on mutation, because the
  // panel can be opened at a scroll position where the bar is already retracted.
  const OPEN = '.meningea-header [data-mobile-nav][open], .meningea-header [aria-expanded="true"]';
  const isOpen = () => document.querySelector(OPEN) !== null;

  new MutationObserver(() => {
    if (isOpen()) setHidden(false);
  }).observe(document.documentElement, {
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-expanded', 'open'],
  });

  window.addEventListener('scroll', onScroll, { passive: true });
  mq.addEventListener('change', onScroll);
  // A reload part-way down the page restores the scroll position without firing a scroll
  // event, so the first state has to be worked out here.
  onScroll();
})();
